import React, { Suspense, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { ARCanvas, Interactive } from '@react-three/xr'
import { useFrame, extend, useThree } from '@react-three/fiber'
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";

import { Environment } from '@react-three/drei'

import Model from './Model'

extend({ OrbitControls });
const Fall = () => "Error";

const colors = ['FD0', 'F00', '0F0', '00F', 'FA0'];

const Vr = () => {
  const navigate = useNavigate();
  const color = colors[Math.floor(Math.random() * 6)];
  console.log(color);

  const catchIt = (color, gl) => {
    let path = `skin/${color}`;
    const session = gl.xr.getSession();
    session.end();
    navigate(path);
  }

  const WithSesh = () => {
    const { gl } = useThree();
    return (
      <Interactive onSelect={() => catchIt(color, gl)} onHover={() => catchIt(color, gl)} onBlur={() => catchIt(color, gl)}>
        <Model onClick={() => catchIt(color, gl)} />
      </Interactive>
    );
  };

  const CameraControls = () => {
    const controls = useRef();
    const { camera, gl: {domElement} } = useThree();
    useFrame((state) => controls.current.update());
    return <orbitControls ref={controls} args={[camera, domElement]} />;
  };
  
  return (
    <ARCanvas sessionInit={{ requiredFeatures: ['hit-test'] }}>
      <Suspense fallback={<Fall />}>
        <WithSesh />
        <ambientLight color={`#${color}`} />
        <pointLight position={[10, 10, 10]} color={`#${color}`} />
        <CameraControls />
        <Environment preset="sunset" />
      </Suspense>
    </ARCanvas>
  )
};

export default Vr;
